// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_gt-6";
export var emphasizeQuantity = "_gt-3";
export var flatBottomCorners = "_gt-5";
export var productImage = "_gt-0";
export var quantityContainer = "_gt-2";
export var tooltip = "_gt-1";
export var wrapAndEllipsesOverflow = "_gt-4";